module.exports = __webpack_public_path__ + "media/img/ms-icon-70x70-1f577d2d7727808a167396809e0059c7.png";